import { useEventListener } from '@vueuse/core';

export function useEscapeKey(isOpen: Ref<boolean>, handler: () => void) {
  useEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key === 'Escape' && isOpen.value) handler();
  });
}
